import React from 'react'

const Heading = ({children}) => {
  return (
    <h1 className='font-extralight text-3xl mb-6 dark:text-white'>{children}</h1>
  )
}

export default Heading